module.exports = __webpack_public_path__ + "img/swap2.316dc552.svg";